import { render, staticRenderFns } from "./LandUseAndCover.vue?vue&type=template&id=3b13fddd&scoped=true"
import script from "./LandUseAndCover.vue?vue&type=script&lang=js"
export * from "./LandUseAndCover.vue?vue&type=script&lang=js"
import style0 from "./LandUseAndCover.vue?vue&type=style&index=0&id=3b13fddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13fddd",
  null
  
)

export default component.exports